import axios from 'axios';

const BASE_URL =
  (import.meta.env.VITE_API_URL as string | undefined) || 'http://localhost:3001';

// Deliberately no default Content-Type. Axios 1.x derives it per request:
//   - plain object   → application/json
//   - FormData       → multipart/form-data; boundary=… (with the boundary)
//   - URLSearchParams → application/x-www-form-urlencoded
// A default here would clobber the multipart boundary on file uploads,
// breaking multer parsing on the server (400 "No file uploaded"). This
// matters for: avatar upload, AI agent file attach, Border Buddy file
// attach, bulk-import file path.
export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

export interface GeoHint {
  country: string | null;
  city: string | null;
  source: 'cloudflare' | 'none';
}

export async function getGeoHint(): Promise<GeoHint> {
  const r = await api.get<GeoHint>('/api/geo/hint');
  return r.data;
}
